<template>
  <aside class="w-56 bg-white border-r border-gray-200 h-full rounded-xl mb-4" >
    <div class="p-4">
      <div class="space-y-6">
        <div>
          <div class="text-sm font-medium text-gray-500 mb-3">账户管理</div>
          <ul class="space-y-2">
            <li v-show="userinfo.is_approve">
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'index' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToProfile"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-user-line"></i>
                </div>
                个人资料
              </button>
            </li>
            <li>
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'security' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToSecurity"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-shield-line"></i>
                </div>
                账户安全
              </button>
            </li>
          </ul>
        </div>
        <div>
          <div class="text-sm font-medium text-gray-500 mb-3">订单管理</div>
          <ul class="space-y-2">
            <li>
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'orderlist' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToOrderList"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-time-line"></i>
                </div>
                租赁订单
              </button>
            </li>
          </ul>
        </div>
        <div>
          <div class="text-sm font-medium text-gray-500 mb-3">我的服务</div>
          <ul class="space-y-2">
            <li>
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'favorites' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToFavorites"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-heart-line"></i>
                </div>
                收藏夹
              </button>
            </li>
            <li>
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'invoices' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToInvoices"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-file-list-line"></i>
                </div>
                发票管理
              </button>
            </li>
            <li>
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'addresses' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToAddresses"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-map-pin-line"></i>
                </div>
                地址管理
              </button>
            </li>
          </ul>
        </div>
        <div>
          <div class="text-sm font-medium text-gray-500 mb-3">联盟营销</div>
          <ul class="space-y-2">

            <li v-if="userinfo.is_approve">
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'preorderadd' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToPreOrderAdd"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-time-line"></i>
                </div>
                创建预订单
              </button>
            </li>
             <li v-if="userinfo.is_approve">
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'preorderlist' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToPreOrderList"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-time-line"></i>
                </div>
                预订单列表
              </button>
            </li>
            <li>
              <button
                class="w-full flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors"
                :class="activeItem === 'approve' ? 'text-primary bg-blue-50' : 'text-gray-600 hover:text-primary hover:bg-blue-50'"
                @click="goToApprove"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-time-line"></i>
                </div>
                认证分销伙伴
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'LeftNav',
  props: {
    activeItem: {
      type: String,
      default: 'profile'
    },
    fixed: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      userinfo: {}
    }
  },
  // 获取用户信息
  async mounted() {
    this.userinfo = JSON.parse(localStorage.getItem('userInfo')) || {}

  },
  methods: {
    goToProfile() {
      this.$router.push('/ucenter/index')
    },
    goToSecurity() {
      this.$router.push('/ucenter/security')
    },
    goToOrderList() {
      // 实际项目中可以替换为真实的租赁中订单页面路由
      this.$router.push('/ucenter/orderlist')
    },
    goToOrderHistory() {
      // 实际项目中可以替换为真实的历史订单页面路由
      this.$router.push('/ucenter/orderhistory')
    },
    goToFavorites() {
      // 实际项目中可以替换为真实的收藏夹页面路由
      this.$router.push('/ucenter/favorites')
    },
    goToInvoices() {
      // 实际项目中可以替换为真实的发票管理页面路由
      this.$router.push('/ucenter/invoices')
    },
    goToAddresses() {
      // 实际项目中可以替换为真实的地址管理页面路由
      this.$router.push('/ucenter/addresses')
    },
    goToPreOrderAdd() {
      // 实际项目中可以替换为真实的预订单创建页面路由
      this.$router.push('/ucenter/preorderadd')
    },
    goToPreOrderList() {
      // 实际项目中可以替换为真实的预订单列表页面路由
      this.$router.push('/ucenter/preorderlist')
    },
    goToApprove() {
      // 实际项目中可以替换为真实的认证页面路由
      this.$router.push('/ucenter/approve')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LeftNav.vue